import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

import { ICreateRoutingProjectForm } from 'features/RoutingProjects/types'

const nameMessages = defineMessages({
  required: {
    id: 'routingProjects.create.name.required',
    defaultMessage: 'The name is required'
  },
  min: {
    id: 'routingProjects.create.name.min',
    defaultMessage: 'The name must be at least {min} characters'
  }
})

const tagsMessages = defineMessages({
  min: {
    id: 'routingProjects.create.tags.min',
    defaultMessage: 'The tag must be at least {min} characters'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<ICreateRoutingProjectForm> => {
  return yup.object().shape({
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .min(2, ({ min }) => intl.formatMessage(nameMessages.min, { min })),
    tags: yup.array().of(
      yup
        .string()
        .required()
        .min(2, ({ min }) => intl.formatMessage(tagsMessages.min, { min }))
    )
  })
}
